import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import FlowEngine from '../../amsRequest/flowengine';
import ams from '../../common/ams';
import _Object from '../../common/object';
var defaultOption = {
  activityId: '',
  // 活动的ID
  gameId: '',
  pageNow: 1,
  isForce: false,
  everyUpdate: false,
  pageSize: null,
  getData: null,
  // 直接获得数据
  matchArea: true,
  // 匹配替换大区信息 默认为true
  sNeedSubmitPopDiv: true
};
var GET_GIFT_DATA = {}; // 缓存该数据

var sendAmsRequest = function sendAmsRequest(option) {
  return new Promise(function (resolve, reject) {
    var activityId = option.activityId,
        iAMSActivityId = option.iAMSActivityId,
        iFlowId = option.iFlowId,
        sNeedSubmitPopDiv = option.sNeedSubmitPopDiv,
        pageNow = option.pageNow,
        pageSize = option.pageSize,
        activityList = option.activityList,
        everyUpdate = option.everyUpdate,
        isForce = option.isForce,
        _option$sData = option.sData,
        sData = _option$sData === void 0 ? {} : _option$sData;
    var dataName = "".concat(activityId).replace(/\|/g, '$'); // 首先查找一下当前activityId和当前页的记录是否已经存在。

    var hasAllMyGiftList = GET_GIFT_DATA["".concat(dataName, "_").concat(option.pageNow)];

    if (hasAllMyGiftList && !everyUpdate) {
      if (!isForce) {
        resolve(hasAllMyGiftList);
      }
    }

    var submitData = _objectSpread({
      iPageSize: pageSize,
      iPageNow: pageNow,
      activityList: activityList || ''
    }, sData); // 使用AMS的提交方式


    var FlowSubmitJson = {
      iActivityId: iAMSActivityId,
      // AMS活动号
      iFlowId: iFlowId,
      // 抽奖流程ID
      sData: submitData,
      sNeedSubmitPopDiv: sNeedSubmitPopDiv,
      fFlowSubmitEnd: function fFlowSubmitEnd(MyGiftListObject) {
        if (MyGiftListObject.iRet == 0) {
          MyGiftListObject = _Object.decode(MyGiftListObject);

          for (var i = 0; i < MyGiftListObject.myGiftList.length; i++) {
            var _ref = MyGiftListObject.myGiftList[i] || {},
                _ref$dtGetPackageTime = _ref.dtGetPackageTime,
                dtGetPackageTime = _ref$dtGetPackageTime === void 0 ? '' : _ref$dtGetPackageTime,
                sAreaName = _ref.sAreaName,
                sPackageName = _ref.sPackageName;

            MyGiftListObject.myGiftList[i].getTime = dtGetPackageTime;
            MyGiftListObject.myGiftList[i].getShortTime = dtGetPackageTime.substring(5, 16); // try{
            //     MyGiftListObject.myGiftList[i].uin = LoginManager.getUin();
            // }catch(e){
            //     console.log(e)
            // }

            MyGiftListObject.myGiftList[i].areaName = sAreaName;
            MyGiftListObject.myGiftList[i].packageName = sPackageName;
          }

          GET_GIFT_DATA["".concat(dataName, "_").concat(option.pageNow)] = MyGiftListObject;
        }

        resolve(MyGiftListObject);
      },
      fFlowSubmitFailed: function fFlowSubmitFailed(err) {
        reject(err);
      }
    };
    FlowEngine.submit(FlowSubmitJson)["catch"](function (err) {
      reject(err);
    });
  });
}; // 获取个人奖品记录列表，可支持多个活动列表


export default function (opt, pageNow) {
  var iActivityId = opt.iActivityId,
      iFlowId = opt.iFlowId,
      flowConfig = opt.flowConfig;
  return ams.amsInit(iActivityId, iFlowId, flowConfig).then(function (_ref2) {
    var config = _ref2.config,
        flow = _ref2.flow;

    var option = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, defaultOption), config), flow), {}, {
      pageNow: pageNow
    }); // if(!option.activityId){
    //     const msg = 'activityId未设置';
    //     throw msg
    // }


    return option;
  }).then(function (option) {
    return sendAmsRequest(option);
  });
}